import { render } from "./RemarketingMix.vue?vue&type=template&id=73f65c88&scoped=true"
import script from "./RemarketingMix.vue?vue&type=script&lang=js"
export * from "./RemarketingMix.vue?vue&type=script&lang=js"

import "./RemarketingMix.vue?vue&type=style&index=0&id=73f65c88&lang=scss&scoped=true"

import exportComponent from "/data/projects/dev_private_futurelab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73f65c88"]])

export default __exports__